module.exports = __webpack_public_path__ + "img/notification-widget-illustration.ac79a27a.png";